import React, { useState } from "react";
import { AppBar, Box, IconButton, Toolbar, Typography, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const DateInput = ({ value, onChange }) => {
    const navigate = useNavigate();
    const [selectedDate, setSelectedDate] = useState(value ? dayjs(value) : dayjs());

    const handleBack = () => {
        navigate(-1);
    };

    const handleSave = () => {
        const formattedDate = selectedDate.format("YYYY-MM-DD"); // Форматируем дату без времени
        if (onChange) onChange(formattedDate);
        navigate(-1);
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
            <AppBar position="static" color="default">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleBack} aria-label="Назад">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Выберите дату
                    </Typography>
                </Toolbar>
            </AppBar>

            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
                <Box sx={{ display: "flex", justifyContent: "center"}}>
                    <StaticDatePicker
                        calendars={2}
                        displayStaticWrapperAs="desktop"
                        value={selectedDate}
                        onChange={(newValue) => setSelectedDate(newValue)}
                        renderInput={() => null}
                    />
                </Box>
            </LocalizationProvider>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Button variant="contained" color="primary" onClick={handleSave}>
                    Сохранить
                </Button>
            </Box>
        </Box>
    );
};

export default DateInput;
